import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';
import { MediaGroup } from 'src/app/models/media/media-group.model';
import { ViewerService } from 'src/app/services/viewer.service';
import { ViewMode } from 'src/app/shared-new/enums/view-mode.emun';

@Component({
  selector: 'app-scope-report',
  templateUrl: './scope-report.component.html',
  styleUrls: ['./scope-report.component.scss'],
})
export class ScopeReportComponent implements OnInit {
  @Input() mp4StudyFiles: StudyFile[] = [];
  @Input() pdfStudyFiles: StudyFile[] = [];
  @Input() mediaGroups: MediaGroup[] = [];
  @Input() mediaCategories: MediaCategory[] = [];
  @Input() viewMode: ViewMode = ViewMode.DRAFT;
  @Output('createStudyFile')
  createStudyFile: EventEmitter<File> = new EventEmitter<File>();

  ViewMode = ViewMode;

  currentMp4Count = 0;
  currentPdfCount = 0;
  showVideo = false;
  videoUrl: string = '';
  constructor(private viwerService: ViewerService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['pdfStudyFiles']?.currentValue &&
      changes['pdfStudyFiles']?.currentValue?.length !== this.currentPdfCount
    ) {
      this.currentPdfCount = changes['pdfStudyFiles']?.currentValue?.length;
    }

    if (
      changes['mp4StudyFiles']?.currentValue &&
      changes['mp4StudyFiles']?.currentValue?.length !== this.currentMp4Count
    ) {
      this.currentMp4Count = changes['mp4StudyFiles']?.currentValue?.length;
    }
  }

  selectMp4Files(files: File[]): void {
    this.createStudyFile.emit(files[0]);
    this.currentMp4Count = 0;
  }

  selectPdfFiles(files: File[]): void {
    this.createStudyFile.emit(files[0]);
    this.currentPdfCount = 0;
  }

  playVideo(studyFile: StudyFile): void {
    const study: any = {
      saleId: studyFile.saleId,
      horseId: studyFile.horseId,
    };
    this.viwerService.playVideo(study, studyFile);
  }

  openPdf(studyFile: StudyFile): void {
    const study: any = {
      saleId: studyFile.saleId,
      horseId: studyFile.horseId,
    };
    this.viwerService.openPdf(study, studyFile);
  }
}
